import React from "react";
import {
    TextField,
    Typography,
    Grid,
    Paper,
    FormHelperText
} from '@material-ui/core';
import HeadOfCauseListInput from "features/Tdsat/components/HeadOfCauseListInput";
import CauseListTypeInput from "features/Tdsat/components/CauseListTypeInput";


const BottomCaseListing = ({classes, formData, handleInputChange, formErrorsCase}) => {
    
    return(
        <Paper className={classes.paper}>
            <Grid container spacing={2}>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <HeadOfCauseListInput
                          onChange={handleInputChange}
                          headOfListing={formData?.headOfListing}
                          isRequired={true}
                        />
                        {formErrorsCase.headOfListing && <FormHelperText error>{formErrorsCase.headOfListing}</FormHelperText>}
                    </Grid>
                    <Grid item xs={6}>
                        <Typography className={classes.label}>Priority Serial</Typography>
                        <TextField
                            name="prioritySerial"
                            fullWidth
                            margin="none"
                            variant="outlined"
                            value={formData.prioritySerial}
                            onChange={handleInputChange}
                            error={!!formErrorsCase.prioritySerial}
                            helperText={formErrorsCase.prioritySerial}
                        />
                    </Grid>
                    <Grid item xs={6}>
                      <CauseListTypeInput
                        name="causelist_type"
                        value={formData?.causelist_type}
                        onChange={handleInputChange}
                        isInlineLabel={false}
                        required
                        error={formErrorsCase?.causelist_type}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography className={classes.label}>Time Slot</Typography>
                      <TextField
                        name="timeSlot"
                        fullWidth
                        margin="none"
                        variant="outlined"
                        value={formData.timeSlot}
                        onChange={handleInputChange}
                        error={!!formErrorsCase.timeSlot}
                        helperText={formErrorsCase.timeSlot}
                      />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.label}>Remarks</Typography>
                        <TextField
                            name="remarks"
                            fullWidth
                            required
                            margin="none"
                            variant="outlined"
                            value={formData.remarks}
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </Grid>
            </Grid>
        </Paper>
    )
}

export default BottomCaseListing;